module.exports = __webpack_public_path__ + "img/card-row-right.edbb068b.svg";